// PURE Announcement Bar JavaScript
// Add click handler for discount/links to a slide
const addSlideClickHandler = (slide) => {
  if (slide.dataset.target && !slide.hasAttribute('data-click-handler-added')) {
    slide.setAttribute('data-click-handler-added', 'true');
    slide.addEventListener('click', async (event) => {
      // Don't trigger if clicking on a button or link inside
      if (event.target.closest('button, a')) {
        return;
      }
      
      const target = event.currentTarget.dataset.target;
      let link = null;

      if (target !== undefined) {
        if (target.includes('/')) {
          link = target;
          window.location.href = link;
        } else {
          link = `${window.location.origin}/discount/${target}`;
  
          fetch(link)
          .then((response) => response.status)
          .then((responseStatus) => {
            if (responseStatus === 200) {
              const discountAppliedText = 'Discount applied!';
              showPureAnnouncementsDiscountNotification(discountAppliedText);
            }
          })
          .catch((e) => {
            console.error(e);
          });
        }
      }
    });
  }
};

const animatePureAnnouncements = (slide) => {
  return new Promise(resolve => {
    slide.addEventListener('transitionend', () => {
      slide.ontransitionend = null;
      slide.style.transition = 'none';
      resolve(true);
    });
    
    slide.style.transition = 'opacity 0.25s ease-in-out';
    slide.style.opacity = 1;
    slide.style.transform = 'translateY(0)';
    slide.classList.add('active');

    // Add click handler for discount/links
    addSlideClickHandler(slide);
  });
};

const showPureAnnouncementsDiscountNotification = async (text) => {
  const announcementBar = document.querySelector('.pure-header-announcement');
  const element = `
    <div class="pure-announcements-discount-notification">
      <span>${text}</span>
    </div>
  `;

  if (announcementBar.querySelector('.pure-announcements-discount-notification') === null) {
    announcementBar.insertAdjacentHTML('beforeend', element);
  }

  setTimeout(() => {
    const existingNotificationsToClear = document.querySelectorAll('.pure-announcements-discount-notification');
    for (const notification of existingNotificationsToClear) {
      notification.remove();
    }
  }, 3500);
};

const updatePureCountdown = (timerElement) => {
  // Parse "MM/DD/YYYY hh:mm AM/PM" or legacy "MM/DD/YYYY HH:MM[:SS]"
  const dateTimeString = (timerElement.dataset.endDate || '').trim();
  if (!dateTimeString) return false;

  const parts = dateTimeString.split(/\s+/);
  const datePart = parts[0] || '';
  const timePartRaw = parts[1] || '';
  const ampm = (parts[2] || '').toUpperCase();

  const [month, day, year] = (datePart || '').split('/');
  let hour = 23, minute = 59, second = 59;

  if (timePartRaw) {
    const timeParts = timePartRaw.split(':');
    hour = parseInt(timeParts[0] || '0', 10);
    minute = parseInt(timeParts[1] || '0', 10);
    if (timeParts.length > 2) {
      second = parseInt(timeParts[2] || '0', 10);
    } else {
      second = 0;
    }
  }

  // Convert 12h to 24h if AM/PM provided
  if (ampm === 'AM' || ampm === 'PM') {
    if (ampm === 'PM' && hour !== 12) hour += 12;
    if (ampm === 'AM' && hour === 12) hour = 0;
  }

  const endDate = new Date(
    parseInt(year, 10),
    parseInt(month, 10) - 1,
    parseInt(day, 10),
    hour,
    minute,
    second
  );
  
  const now = new Date();
  const timeLeft = endDate - now;

  if (timeLeft <= 0) {
    // Hide the entire announcement section when countdown expires
    const slideElement = timerElement.closest('.pure-announcement-slide');
    if (slideElement) {
      const sectionElement = slideElement.closest('section.pure-header-announcement');
      if (sectionElement) {
        sectionElement.style.display = 'none';
      }
    }
    return false; // Timer expired
  }

  const hours = Math.floor(timeLeft / (1000 * 60 * 60));
  const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  const hoursSpan = timerElement.querySelector('.pure-countdown-hours');
  const minutesSpan = timerElement.querySelector('.pure-countdown-minutes');
  const secondsSpan = timerElement.querySelector('.pure-countdown-seconds');

  if (hoursSpan) hoursSpan.textContent = hours.toString().padStart(2, '0');
  if (minutesSpan) minutesSpan.textContent = minutes.toString().padStart(2, '0');
  if (secondsSpan) secondsSpan.textContent = seconds.toString().padStart(2, '0');

  return true; // Timer still running
};

const startPureCountdownTimers = () => {
  const countdownTimers = document.querySelectorAll('.pure-countdown-timer');
  
  countdownTimers.forEach(timer => {
    // Update immediately
    updatePureCountdown(timer);
    
    // Set up interval to update every second
    const intervalId = setInterval(() => {
      const stillRunning = updatePureCountdown(timer);
      if (!stillRunning) {
        clearInterval(intervalId);
      }
    }, 1000);
  });
};

const setUpPureSection = async (container) => {
  if (!container) return;
  const allSlides = Array.from(container.querySelectorAll('.pure-announcement-slide'));
  const sectionElement = container.closest('section.pure-header-announcement');

  // Reveal immediately; AWS process disables/filters blocks in index.json
  if (sectionElement) {
    sectionElement.classList.add('pure-announcement-ready');
    sectionElement.style.display = '';
  }

  const slides = allSlides;

  if (slides.length === 0) return;
  
  // Add click handlers to all slides that have a discount link
  slides.forEach(slide => {
    addSlideClickHandler(slide);
  });

  // If there's only one eligible slide, render it immediately without rotation delays
  if (slides.length === 1) {
    const only = slides[0];
    only.classList.add('active');
    only.style.opacity = 1;
    only.style.transform = 'translateY(0)';
    // Add click handler for discount/links
    addSlideClickHandler(only);
    return;
  }
  
  const wait = () => {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, parseInt(container.dataset.interval || window.pureAnnouncementsInterval || 5000, 10));
    });
  };

  let index = 0;

  while (slides.length > 0) {
    // Hide all slides
    slides.forEach(slide => {
      slide.classList.remove('active');
      slide.style.opacity = 0;
      slide.style.transform = 'translateY(-100px)';
    });
    
    // Show current slide
    await animatePureAnnouncements(slides[index]);
    await wait();
    
    // Hide current slide
    slides[index].classList.remove('active');
    slides[index].style.opacity = 0;
    slides[index].style.transform = 'translateY(-100px)';
    
    index = ++index % slides.length;
  }
};

// Set CSS variables on section elements
const setPureAnnouncementVariables = () => {
  const wrappers = document.querySelectorAll('.pure-announcement-wrapper');
  wrappers.forEach(wrapper => {
    const sectionElement = wrapper.closest('section.pure-header-announcement');
    if (sectionElement) {
      // Get CSS variables from the wrapper's computed styles
      const wrapperStyles = window.getComputedStyle(wrapper);
      const textColor = wrapperStyles.getPropertyValue('--pure-announcements-text-color').trim();
      const bgColor = wrapperStyles.getPropertyValue('--pure-announcements-background-color').trim();
      
      // Apply to section element if they exist
      if (textColor && textColor !== '') {
        sectionElement.style.setProperty('--pure-announcements-text-color', textColor);
      }
      if (bgColor && bgColor !== '') {
        sectionElement.style.setProperty('--pure-announcements-background-color', bgColor);
      }
    }
  });
};

// Initialize everything
document.addEventListener('DOMContentLoaded', () => {
  setPureAnnouncementVariables();
  const containers = document.querySelectorAll('.pure-announcement-container');
  containers.forEach((c) => setUpPureSection(c));
  if (containers.length > 0) startPureCountdownTimers();
  applyStickyPositioning();
});

document.addEventListener('shopify:section:load', (event) => {
  setPureAnnouncementVariables();
  const scope = event && event.target ? event.target : document;
  const containers = scope.querySelectorAll ? scope.querySelectorAll('.pure-announcement-container') : [];
  containers.forEach((c) => setUpPureSection(c));
  if (containers.length > 0) startPureCountdownTimers();
  applyStickyPositioning();
});

// Apply sticky positioning if enabled
const applyStickyPositioning = () => {
  const stickyWrappers = document.querySelectorAll('.pure-announcement-sticky');
  stickyWrappers.forEach(wrapper => {
    const section = wrapper.closest('section.pure-header-announcement');
    if (section) {
      section.style.position = 'sticky';
      section.style.top = '0';
      section.style.zIndex = '1000';
    }
  });
};

// Ensure proper positioning on window load
window.addEventListener('load', () => {
  const pureAnnouncements = document.querySelectorAll('.pure-header-announcement');
  pureAnnouncements.forEach(pureAnnouncement => {
    // Only set to relative if it's not sticky
    const isSticky = pureAnnouncement.querySelector('.pure-announcement-sticky');
    if (!isSticky) {
      pureAnnouncement.style.position = 'relative';
      pureAnnouncement.style.zIndex = '100';
    }
  });
  // Apply sticky positioning after checking
  applyStickyPositioning();
});